import Translate from "../Translate";

export function shareWithAPI (link) {
    let navigator : any = window.navigator;

    if (navigator && navigator.share) {
        navigator.share({
            title: Translate.path("views.site_pages.refer_a_friend_v2.share_api_title"),
            text: Translate.path("views.site_pages.refer_a_friend_v2.share_api_text"),
            url: link
        }).then(() => {
            //Confetti?
        })
    }
}
